import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import { Site } from '../../features/sites/sitesSlice';

const sitesService = {
  getSites: async (): Promise<Site[]> => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.get<Site[]>(
      `/identity/sites/GetSites`,
      config,
    );
    return response.data;
  },
  getAccountSites: async (accountId: string): Promise<Site[]> => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
      params: { accountId },
    };

    const response = await axios.get<Site[]>(
      `/identity/sites/GetAccountSites`,
      config,
    );
    return response.data;
  },
  updateAccountSites: async (
    accountId: string,
    selectedSites: Site[],
  ): Promise<void> => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
      params: { accountId },
    };

    const siteIds = selectedSites.map(site => site.id);

    const response = await axios.post(
      `/identity/sites/UpdateAccountSites`,
      siteIds,
      config,
    );
    return response.data;
  },
};

export default sitesService;
